import { render } from "./TextBlock.vue?vue&type=template&id=1435f05a&scoped=true"
const script = {}

import "./TextBlock.vue?vue&type=style&index=0&id=1435f05a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1435f05a"]])

export default __exports__